import {
  useMutation,
  UseMutationOptions,
  useQueryClient,
} from '@tanstack/react-query';
import { IFHError } from 'src/apis/HttpBaseApiWrapper';
import { useStudentsService } from 'src/apis/students/useStudentsService';
import { IStudentSubjectAssessment } from 'src/apis/students/studentsAssessment.interfaces';
import { getStudentSubjectBasedAssessmentListKey } from './useStudentSubjectBasedAssessmentListHook';

type TMutationError = IFHError<{ message: string }>;

export const useAddStudentAssessmentHook = (
  options?: UseMutationOptions<
    IStudentSubjectAssessment,
    TMutationError,
    IStudentSubjectAssessment,
    unknown
  >
) => {
  const { addStudentSubjectBasedStudentAssessment } = useStudentsService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (assessment: IStudentSubjectAssessment) =>
      addStudentSubjectBasedStudentAssessment(assessment),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getStudentSubjectBasedAssessmentListKey],
      });
    },
    ...options,
  });
};

export const usePatchStudentAssessmentHook = (
  options?: UseMutationOptions<
    IStudentSubjectAssessment,
    TMutationError,
    IStudentSubjectAssessment,
    unknown
  >
) => {
  const { patchStudentSubjectBasedStudentAssessment } = useStudentsService();
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (assessment: IStudentSubjectAssessment) =>
      patchStudentSubjectBasedStudentAssessment(assessment),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [getStudentSubjectBasedAssessmentListKey],
      });
    },
    ...options,
  });
};
